/**
 * @desc 导入费用明细
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: Array<defs.tms.CostRequestReportRequestDto>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/costRequest/importCostRequestList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
